import { encryptId, formatUrlString } from "../services/apiService";
import dashboardIcon from "../assets/icons/dashboard.webp";
import viewIcon from "../assets/icons/view.png";
import inboxIcon from "../assets/icons/index.webp";
import profileIcon from "../assets/icons/profile-setting.webp";
import appointmentsIcon from "../assets/icons/appointments.webp";
import medicalRecordsIcon from "../assets/icons/medicalreports.webp";
import wishlistIcon from "../assets/icons/wishlist.png";
import notificationsIcon from "../assets/icons/notifications.webp";
import policiesIcon from "../assets/icons/policy.webp";
import bookAppointmentIcon from "../assets/icons/booknewappointment.png";
import doctorIcon from "../assets/images/doctor-icon.png";
import hospitalIcon from "../assets/images/hospital-icon.png";
import diagnosticIcon from "../assets/images/Diagnostic-icon.png";
import shopIcon from "../assets/images/shop-icon.png";
import userIcon from "../assets/images/user.png";
import packagesIcon from "../assets/icons/wishlist.png"; // Fallback for packages
import settingsIcon from "../assets/icons/profile-setting.webp";
import articleIcon from "../assets/icons/medicalreports.webp";



class SidebarController {
  constructor() {
    this.menuCache = new Map();
  }

  /**
   * Build menu based on user type and permissions
   * @param {Object} userdata - User data object
   * @param {Array} userPermissions - Array of user permissions
   * @param {string} displayName - User display name
   * @returns {Array} Menu array
   */
  buildMenu(userdata, userPermissions = [], displayName = "", setSelectedPage = "") {
    let permissionjson = [];

    if (typeof userPermissions === 'string') {
      permissionjson = JSON.parse(userPermissions);
    } else {
      permissionjson = userPermissions;
    }

    console.log('permissionjson buildMenu json:', permissionjson);
    const hasPresentUser = localStorage.getItem("presentuser");
    const cacheKey = `${userdata.user_type}_${permissionjson}_${displayName}_${!!hasPresentUser}`;

    if (this.menuCache.has(cacheKey)) {
      return this.menuCache.get(cacheKey);
    }

    let menu = [];

    const localuser = localStorage.getItem("presentuser");
    if (localuser) {
      menu.push({
        icon_type: "icon",
        label: "Return to Dashboard",
        icon: "ti-desktop",
        key: "login_return",
        type: "action",
        action: "login_return"
      });
    }

    switch (userdata.user_type) {
      case "administrator":
      case "admin":
      case "superadmin":
      case "super_administrator":
        menu = this.buildAdminMenu(userdata, userPermissions, setSelectedPage);
        break;
      case "staff":
        menu = this.buildStaffMenu(userdata, userPermissions, setSelectedPage);
        break;
      case "doctor":
      case "doctors":
        menu = this.buildDoctorMenu(userdata, displayName);
        break;
      case "hospitals":
      case "hospital":
        menu = this.buildHospitalMenu(userdata, displayName);
        break;
      case "pharmacy":
        menu = this.buildPharmacyMenu(userdata);
        break;
      case "insurance":
        menu = this.buildInsuranceMenu(userdata);
        break;
      case "blood_bank":
        menu = this.buildBloodBankMenu(userdata);
        break;
      case "diagnostic":
        menu = this.buildDiagnosticMenu(userdata);
        break;

      case "user":
      case "regular_users":
      case "regular users":
      case "patient":
        menu = this.buildUserMenu(userdata, displayName);
        break;
      default:
        menu = this.buildGenericMenu(userdata);
        break;
    }

    // Process menu to add submenu support
    const processedMenu = this.processMenuForSubmenus(menu);

    this.menuCache.set(cacheKey, processedMenu);
    return processedMenu;
  }

  /**
   * Check if user has specific permission
   * @param {Array} userPermissions - User permissions array
   * @param {string} permission - Permission to check
   * @returns {boolean}
   */
  hasPermission(userPermissions, permission) {
    console.log('Permissions hasPermission Input:', userPermissions);
    console.log('Permission to check:', permission);

    // Parse if it's a string
    if (typeof userPermissions === 'string') {
      try {
        userPermissions = JSON.parse(userPermissions);
      } catch (err) {
        console.error('Error parsing permissions JSON:', err);
        return false;
      }
    }

    // Check if valid array
    if (!Array.isArray(userPermissions)) {
      console.warn('Invalid permissions format, expected array.');
      return false;
    }

    // Check permission existence
    const hasPerm = userPermissions.some(userPerm => {
      if (typeof userPerm === 'object' && userPerm.value) {
        return userPerm.value === permission;
      }
      if (typeof userPerm === 'string') {
        return userPerm === permission;
      }
      return false;
    });

    console.log(`Permission "${permission}" found:`, hasPerm);
    return hasPerm;
  }


  /**
   * Check if menu item should be shown based on role and permissions
   * @param {Object} userdata - User data
   * @param {Array} userPermissions - User permissions
   * @param {string} requiredRole - Required role
   * @param {string} requiredPermission - Required permission
   * @returns {boolean}
   */
  shouldShowMenuItem(userdata, userPermissions, requiredRole, requiredPermission, selectedPage) {
    console.log('userPermissions shouldShowMenuItem :', userPermissions);
    console.log('requiredPermission shouldShowMenuItem :', requiredPermission);
    if (userdata.user_type === "administrator") return true;
    if (requiredRole && userdata.user_type !== requiredRole) return false;
    if (requiredPermission && !this.hasPermission(userPermissions, requiredPermission)) return false;
    return true;
  }

  /**
   * Build admin/staff menu
   * @param {Object} userdata - User data
   * @param {Array} userPermissions - User permissions
   * @returns {Array} Menu array
   */
  buildAdminMenu(userdata, userPermissions, setSelectedPage) {
    const menu = [];

    // icon: '🏠',
    // label: 'Dashboard',
    // key: 'dashboard',
    // link: '/superadmin/dashboard',
    // active: selectedPage === 'dashboard',

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "view_dashboard"))
      menu.push({
        icon_type: "image",
        label: "Dashboard",
        icon: dashboardIcon,
        key: "superadmin_dashboard",
        link: "/superadmin/dashboard",
        active: setSelectedPage === "dashboard",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "view_profile"))
      menu.push({
        icon_type: "image",
        label: "View My Profile",
        icon: viewIcon,
        key: "superadmin_profile",
        link: "/superadmin/profile",
        active: setSelectedPage === "profile",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "view_inbox"))
      menu.push({
        icon_type: "image",
        label: "Inbox",
        icon: inboxIcon,
        key: "superadmin_inbox",
        link: "/superadmin/inbox",
        active: setSelectedPage === "inbox",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_profile"))
      menu.push({
        icon_type: "image",
        label: "Profile Settings",
        icon: profileIcon,
        key: "superadmin_profile_settings",
        link: "/superadmin/profile-settings",
        active: setSelectedPage === "profile_settings",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_specialities"))
      menu.push({
        icon_type: "image",
        label: "Specialities & Services",
        icon: medicalRecordsIcon,
        key: "superadmin_specialities",
        link: "/superadmin/specialities",
        active: setSelectedPage === "specialities",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_services"))
      menu.push({
        icon_type: "image",
        label: "Services",
        icon: articleIcon,
        key: "superadmin_services",
        link: "/superadmin/services",
        active: setSelectedPage === "services",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users")) {
      const userChildren = [];

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users_manage_doctors"))
        userChildren.push({
          icon_type: "image",
          label: "Doctors",
          icon: doctorIcon,
          key: "superadmin_doctors",
          link: "/superadmin/doctors",
          active: setSelectedPage === "doctors",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users_manage_hospitals"))
        userChildren.push({
          icon_type: "image",
          label: "Hospitals",
          icon: hospitalIcon,
          key: "superadmin_hospitals",
          link: "/superadmin/hospitals",
          active: setSelectedPage === "hospitals",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users_manage_pharmacies"))
        userChildren.push({
          icon_type: "image",
          label: "Pharmacies",
          icon: shopIcon,
          key: "superadmin_pharmacies",
          link: "/superadmin/pharmacies",
          active: setSelectedPage === "pharmacies",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users_manage_patients"))
        userChildren.push({
          icon_type: "image",
          label: "Regular Users",
          icon: userIcon,
          key: "superadmin_patients",
          link: "/superadmin/patients",
          active: setSelectedPage === "patients",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users_insurance_companies"))
        userChildren.push({
          icon_type: "image",
          label: "Insurance Companies",
          icon: policiesIcon,
          key: "superadmin_insurance_companies",
          link: "/superadmin/insurance-companies",
          active: setSelectedPage === "insurance_companies",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users_manage_blood_banks"))
        userChildren.push({
          icon_type: "image",
          label: "Blood Banks",
          icon: diagnosticIcon,
          key: "superadmin_blood_banks",
          link: "/superadmin/blood-banks",
          active: setSelectedPage === "blood_banks",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users_manage_ambulances"))
        userChildren.push({
          icon_type: "image",
          label: "Ambulances",
          icon: medicalRecordsIcon,
          key: "superadmin_ambulances",
          link: "/superadmin/ambulances",
          active: setSelectedPage === "ambulances",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users_manage_medical_stores"))
        userChildren.push({ path: "/superadmin/medical-stores", label: "Medical Stores", icon: shopIcon, icon_type: "image", level: 1 });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users_manage_medical_students"))
        userChildren.push({
          icon_type: "image",
          label: "Medical Students",
          icon: userIcon,
          key: "superadmin_medical_students",
          link: "/superadmin/medical-students",
          active: setSelectedPage === "medical_students",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users_manage_medical_technicians"))
        userChildren.push({
          icon_type: "image",
          label: "Medical Technicians",
          icon: userIcon,
          key: "superadmin_medical_technicians",
          link: "/superadmin/medical-technicians",
          active: setSelectedPage === "medical_technicians",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users_manage_medical_labs"))
        userChildren.push({
          icon_type: "image",
          label: "Medical Labs",
          icon: diagnosticIcon,
          key: "superadmin_medical_labs",
          link: "/superadmin/medical-labs",
          active: setSelectedPage === "medical_labs",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users_manage_medical_colleges"))
        userChildren.push({
          icon_type: "image",
          label: "Medical Colleges",
          icon: hospitalIcon,
          key: "superadmin_medical_colleges",
          link: "/superadmin/medical-colleges",
          active: setSelectedPage === "medical_colleges",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_users_manage_user_verification_request"))
        userChildren.push({
          icon_type: "image",
          label: "User Verification Request",
          icon: viewIcon,
          key: "user_verification_request",
          link: "/superadmin/user-verification-request",
          active: setSelectedPage === "user_verification_request",
        });

      menu.push({ header: 'User Management' });
      menu.push({ divider: true });


      // Only show Users menu if there are visible children
      if (userChildren.length > 0) {
        menu.push({
          icon_type: "image",
          label: "Users",
          icon: userIcon,
          key: "users",
          link: "/superadmin/users",
          active: setSelectedPage === "users",
          children: userChildren
        });
      }
    }

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_chat_with_designer")) {
      menu.push({
        icon_type: "image",
        label: "Chat with Designer",
        icon: inboxIcon,
        key: "superadmin_chat_with_designer",
        link: "/superadmin/chat-with-designer",
        active: setSelectedPage === "chat_with_designer",
      });
    }

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_leads")) {
      menu.push({
        icon_type: "image",
        label: "Leads Management",
        icon: userIcon,
        key: "superadmin_leads",
        link: "/superadmin/leads",
        active: setSelectedPage === "leads",
      });
    }

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_pharmacies")) {
      const pharmacyChildren = [];

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_pharmacies_manage_pharmacy_products"))
        pharmacyChildren.push({
          icon_type: "image",
          label: "Pharmacy Products",
          icon: shopIcon,
          key: "superadmin_pharmacy_products",
          link: "/superadmin/pharmacy-products",
          active: setSelectedPage === "pharmacy_products",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_pharmacies_manage_pharmacy_categories"))
        pharmacyChildren.push({
          icon_type: "image",
          label: "Pharmacy Categories",
          icon: articleIcon,
          key: "superadmin_pharmacy_categories",
          link: "/superadmin/pharmacy-categories",
          active: setSelectedPage === "pharmacy_categories",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_pharmacies_manage_pharmacy_brands"))
        pharmacyChildren.push({
          icon_type: "image",
          label: "Pharmacy Brands",
          icon: shopIcon,
          key: "superadmin_pharmacy_brands",
          link: "/superadmin/pharmacy-brands",
          active: setSelectedPage === "pharmacy_brands",
        });

      // Only show Pharmacy Products menu if there are visible children
      if (pharmacyChildren.length > 0) {
        menu.push({
          icon_type: "image",
          label: "Pharmacy Products",
          icon: shopIcon,
          key: "superadmin_pharmacy_products_main",
          link: "/superadmin/pharmacy-products",
          active: setSelectedPage === "pharmacy_products",
          children: pharmacyChildren
        });
      }
    }



    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_banners")) {
      const bannerChildren = [];

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_banners_manage_banners"))
        bannerChildren.push({
          icon_type: "image",
          label: "Banners",
          icon: articleIcon,
          key: "superadmin_banners",
          link: "/superadmin/banners",
          active: setSelectedPage === "banners",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_banners_manage_banner_settings"))
        bannerChildren.push({
          icon_type: "image",
          label: "Banner Settings",
          icon: settingsIcon,
          key: "superadmin_banner_settings",
          link: "/superadmin/banner-settings",
          active: setSelectedPage === "banner_settings",
        });

      // Only show Banners menu if there are visible children
      if (bannerChildren.length > 0) {
        menu.push({
          icon_type: "image",
          key: "superadmin_banners_main",
          link: "/superadmin/banners",
          active: setSelectedPage === "banners",
          children: bannerChildren,
          icon: articleIcon,
          label: "Banners"
        });
      }
    }

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_front_end")) {
      const frontEndChildren = [];

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_front_end_manage_slides"))
        frontEndChildren.push({
          icon_type: "image",
          label: "Slides",
          icon: articleIcon,
          key: "superadmin_slides",
          link: "/superadmin/front-end/slides",
          active: setSelectedPage === "slides",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_front_end_manage_about_us"))
        frontEndChildren.push({
          icon_type: "image",
          label: "About Us",
          icon: policiesIcon,
          key: "superadmin_about_us",
          link: "/superadmin/front-end/about-us",
          active: setSelectedPage === "about_us",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_front_end_manage_contact_us"))
        frontEndChildren.push({
          icon_type: "image",
          label: "Contact Us",
          icon: inboxIcon,
          key: "superadmin_contact_us",
          link: "/superadmin/front-end/contact-us",
          active: setSelectedPage === "contact_us",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_front_end_manage_privacy_policy"))
        frontEndChildren.push({
          icon_type: "image",
          label: "Privacy Policy",
          icon: policiesIcon,
          key: "superadmin_privacy_policy",
          link: "/superadmin/front-end/privacy-policy",
          active: setSelectedPage === "privacy_policy",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_front_end_manage_terms_conditions"))
        frontEndChildren.push({
          icon_type: "image",
          label: "Terms and Conditions",
          icon: policiesIcon,
          key: "superadmin_terms_and_conditions",
          link: "/superadmin/front-end/terms-and-conditions",
          active: setSelectedPage === "terms_and_conditions",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_front_end_manage_faq"))
        frontEndChildren.push({
          icon_type: "image",
          label: "FAQ",
          icon: medicalRecordsIcon,
          key: "superadmin_faq",
          link: "/superadmin/front-end/faq",
          active: setSelectedPage === "faq",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_front_end_manage_blog"))
        frontEndChildren.push({
          icon_type: "image",
          label: "Blog",
          icon: articleIcon,
          key: "superadmin_blog",
          link: "/superadmin/front-end/blog",
          active: setSelectedPage === "blog",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_front_end_manage_ai_services"))
        frontEndChildren.push({
          icon_type: "image",
          label: "AI Services",
          icon: diagnosticIcon,
          key: "superadmin_ai_services",
          link: "/superadmin/front-end/ai-services",
          active: setSelectedPage === "ai_services",
        });

      // Only show Front End menu if there are visible children
      if (frontEndChildren.length > 0) {
        menu.push({
          icon_type: "image",
          key: "superadmin_front_end",
          link: "/superadmin/front-end",
          active: setSelectedPage === "front_end",
          label: "Front End",
          icon: dashboardIcon,
          children: frontEndChildren
        });
      }
    }


    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_appointments")) {
      const appointmentChildren = [];

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "view_appointments"))
        appointmentChildren.push({
          icon_type: "image",
          label: "Appointment List",
          icon: appointmentsIcon,
          key: "admin_appointment_list",
          link: "/admin/appointments",
          active: setSelectedPage === "appointment_list",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "appointment_settings"))
        appointmentChildren.push({
          icon_type: "image",
          label: "Appointment Settings",
          icon: settingsIcon,
          key: "superadmin_appointment_settings",
          link: "/superadmin/appointment-settings",
          active: setSelectedPage === "appointment_settings",
        });

      // Only show Appointments menu if there are visible children
      if (appointmentChildren.length > 0) {
        menu.push({
          icon_type: "image",
          key: "admin_appointments",
          link: "/admin/appointments",
          active: setSelectedPage === "appointments",
          label: "Appointments",
          icon: appointmentsIcon,
          children: appointmentChildren
        });
      }
    }


    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_articles"))
      menu.push({
        icon_type: "image",
        label: "Manage Article",
        icon: articleIcon,
        key: "superadmin_articles",
        link: "/superadmin/articles",
        active: setSelectedPage === "articles",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_postframes"))
      menu.push({
        icon_type: "image",
        label: "Manage Post Frames",
        icon: articleIcon,
        key: "superadmin_postframes",
        link: "/superadmin/postframe",
        active: setSelectedPage === "postframes",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_posts"))
      menu.push({
        icon_type: "image",
        label: "Manage Posts",
        icon: articleIcon,
        key: "superadmin_posts",
        link: "/superadmin/posts",
        active: setSelectedPage === "posts",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_payouts"))
      menu.push({
        icon_type: "image",
        label: "Payouts Settings",
        icon: appointmentsIcon,
        key: "superadmin_payouts",
        link: "/superadmin/payouts",
        active: setSelectedPage === "payouts",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_professional_website"))
      menu.push({
        icon_type: "image",
        label: "Professional Website",
        icon: viewIcon,
        key: "superadmin_professional_website",
        link: "/superadmin/professional-website",
        active: setSelectedPage === "professional_website",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_sms_email_templates"))
      menu.push({
        icon_type: "image",
        label: "SMS & Email Templates",
        icon: inboxIcon,
        key: "superadmin_sms_email_templates",
        link: "/superadmin/sms-email-templates",
        active: setSelectedPage === "sms_email_templates",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "view_saved_items"))
      menu.push({
        icon_type: "image",
        label: "My Saved Items",
        icon: wishlistIcon,
        key: "superadmin_saved_items",
        link: "/superadmin/saved-items",
        active: setSelectedPage === "saved_items",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_packages"))
      menu.push({
        icon_type: "image",
        label: "Packages",
        icon: packagesIcon,
        key: "superadmin_packages",
        link: "/superadmin/packages",
        active: setSelectedPage === "packages",
      });

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_finances")) {
      const financeChildren = [];

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "view_invoices"))
        financeChildren.push({
          icon_type: "image",
          label: "Invoices",
          icon: articleIcon,
          key: "superadmin_invoices",
          link: "/superadmin/invoices",
          active: setSelectedPage === "invoices",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "income_management"))
        financeChildren.push({
          icon_type: "image",
          label: "Income Management",
          icon: appointmentsIcon,
          key: "superadmin_income_management",
          link: "/superadmin/income",
          active: setSelectedPage === "income_management",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "expenses_management"))
        financeChildren.push({
          icon_type: "image",
          label: "Expenses Management",
          icon: articleIcon,
          key: "superadmin_expenses_management",
          link: "/superadmin/expenses",
          active: setSelectedPage === "expenses_management",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "salary_management"))
        financeChildren.push({
          icon_type: "image",
          label: "Salary Management",
          icon: appointmentsIcon,
          key: "superadmin_salary_management",
          link: "/superadmin/salary-management",
          active: setSelectedPage === "salary_management",
        });

      // Only show Financials menu if there are visible children
      if (financeChildren.length > 0) {
        menu.push({
          icon_type: "image",
          key: "superadmin_finances",
          link: "/superadmin/finances",
          active: setSelectedPage === "finances",
          label: "Finances",
          icon: appointmentsIcon,
          children: financeChildren
        });
      }
    }

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_staff")) {
      const staffChildren = [];

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_staff_transfer"))
        staffChildren.push({
          icon_type: "image",
          label: "Staff Transfer",
          icon: userIcon,
          key: "superadmin_staff_transfer",
          link: "/superadmin/staff-transfer",
          active: setSelectedPage === "staff_transfer",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "view_staff"))
        staffChildren.push({
          icon_type: "image",
          label: "Staff List",
          icon: userIcon,
          key: "superadmin_staff_list",
          link: "/superadmin/staff",
          active: setSelectedPage === "staff_list",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_roles"))
        staffChildren.push({
          icon_type: "image",
          label: "Roles",
          icon: settingsIcon,
          key: "superadmin_roles",
          link: "/superadmin/roles",
          active: setSelectedPage === "roles",
        });

      // Only show Staff Management menu if there are visible children
      if (staffChildren.length > 0) {
        menu.push({
          icon_type: "image",
          key: "superadmin_staff",
          link: "/superadmin/staff",
          active: setSelectedPage === "staff",
          label: "Staff",
          icon: userIcon,
          children: staffChildren
        });
      }
    }

    if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_hrm")) {
      const hrmChildren = [];

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_employees"))
        hrmChildren.push({
          icon_type: "image",
          label: "Employee Management",
          icon: userIcon,
          key: "superadmin_employee_management",
          link: "/superadmin/employee-management",
          active: setSelectedPage === "employee_management",
        });
      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_attendance"))
        hrmChildren.push({
          icon_type: "image",
          label: "Attendance Management",
          icon: medicalRecordsIcon,
          key: "superadmin_attendance_management",
          link: "/superadmin/attendance-management",
          active: setSelectedPage === "attendance_management",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_holidays_leaves"))
        hrmChildren.push({
          icon_type: "image",
          label: "Holidays & Leaves",
          icon: policiesIcon,
          key: "superadmin_holidays_leaves_management",
          link: "/superadmin/holidays-leaves-management",
          active: setSelectedPage === "holidays_leaves_management",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_user_activity"))
        hrmChildren.push({
          icon_type: "image",
          label: "User Activity Tracking",
          icon: viewIcon,
          key: "superadmin_user_activity_tracking",
          link: "/superadmin/user-activity-tracking",
          active: setSelectedPage === "user_activity_tracking",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_salary_sheet"))
        hrmChildren.push({
          icon_type: "image",
          label: "Salary Sheet Preparation",
          icon: articleIcon,
          key: "superadmin_salary_sheet_preparation",
          link: "/superadmin/salary-sheet-preparation",
          active: setSelectedPage === "salary_sheet_preparation",
        });

      if (this.shouldShowMenuItem(userdata, userPermissions, null, "manage_salary"))
        hrmChildren.push({
          icon_type: "image",
          label: "Salary Management",
          icon: appointmentsIcon,
          key: "superadmin_salary_management",
          link: "/superadmin/salary-management",
          active: setSelectedPage === "salary_management",
        });

      // Only show HRM menu if there are visible children
      if (hrmChildren.length > 0) {
        menu.push({
          icon_type: "image",
          key: "superadmin_hrm",
          link: "/superadmin/hrm",
          active: setSelectedPage === "hrm",
          label: "HRM System",
          icon: settingsIcon,
          children: hrmChildren
        });
      }
    }
    ///superadmin/site-settings

    menu.push({
      icon_type: "image",
      key: "superadmin_site_settings",
      link: "/superadmin/site-settings",
      active: setSelectedPage === "site_settings",
      label: "Site Settings",
      icon: settingsIcon,
    });

    menu.push({
      path: "#",
      link: "#",
      label: "Logout",
      icon: settingsIcon,
      icon_type: "image",
      key: "superadmin_logout",
      type: "action",
      action: "logout",
    });

    return menu;
  }

  buildInsuranceMenu(userdata) {
    return [
      {
        path: "/insurance-dashboard",
        link: "/insurance-dashboard",
        label: "Dashboard",
        icon: dashboardIcon,
        icon_type: "image",
        key: "insurance_dashboard",
        type: "link"
      },
      {
        path: "/insurance/policies",
        link: "/insurance/policies",
        label: "Policies",
        icon: policiesIcon,
        icon_type: "image",
        key: "insurance_policies",
        type: "link"
      },
      // { 
      //   path: "/insurance/claims", 
      //   link: "/insurance/claims",
      //   label: "Claims", 
      //   icon: "ti-credit-card",
      //   icon_type: "icon",
      //   key: "insurance_claims",
      //   type: "link"
      // },
      {
        path: "/insurance/payments",
        link: "/insurance/payments",
        label: "Payments",
        icon: appointmentsIcon,
        icon_type: "image",
        key: "insurance_payments",
        type: "link"
      },
      {
        path: "/insurance/customers",
        link: "/insurance/customers",
        label: "Customers",
        icon: userIcon,
        icon_type: "image",
        key: "insurance_customers",
        type: "link"
      },
      {
        path: "/insurance/leads",
        link: "/insurance/leads",
        label: "Leads",
        icon: viewIcon,
        icon_type: "image",
        key: "insurance_leads",
        type: "link"
      },
      {
        path: "/insurance/profile",
        link: "/insurance/profile",
        label: "Profile",
        icon: userIcon,
        icon_type: "image",
        key: "insurance_profile",
        type: "link"
      },
      {
        path: "/insurance/agents",
        link: "/insurance/agents",
        label: "Agents",
        icon: doctorIcon,
        icon_type: "image",
        key: "insurance_agents",
        type: "link"
      },
      {
        path: "/insurance/analytics",
        link: "/insurance/analytics",
        label: "Analytics",
        icon: dashboardIcon,
        icon_type: "image",
        key: "insurance_analytics",
        type: "link"
      },
      {
        path: "/insurance/notifications",
        link: "/insurance/notifications",
        label: "Notifications",
        icon: notificationsIcon,
        icon_type: "image",
        key: "insurance_notifications",
        type: "link"
      },
      {
        path: "/insurance/documents",
        link: "/insurance/documents",
        label: "Documents",
        icon: articleIcon,
        icon_type: "image",
        key: "insurance_documents",
        type: "link"
      },
      {
        path: "/insurance/help",
        link: "/insurance/help",
        label: "Help",
        icon: "ti-help-alt",
        icon_type: "icon",
        key: "insurance_help",
        type: "link"
      },
      {
        path: "#",
        link: "#",
        label: "Logout",
        icon: "ti-shift-right",
        icon_type: "icon",
        key: "insurance_logout",
        type: "action",
        action: "logout"
      },
    ];
  }

  /**
   * Build Blood Bank menu
   * @param {Object} userdata - User data
   * @returns {Array} Menu array
   */
  buildBloodBankMenu(userdata) {
    return [
      {
        path: "/blood-bank/dashboard",
        link: "/blood-bank/dashboard",
        label: "Dashboard",
        icon: dashboardIcon,
        icon_type: "image",
        key: "blood_bank_dashboard",
        type: "link"
      },
      {
        path: "/blood-bank/blood-groups",
        link: "/blood-bank/blood-groups",
        label: "Blood Groups",
        icon: "ti-heart",
        icon_type: "icon",
        key: "blood_bank_blood_groups",
        type: "link"
      },
      {
        path: "/blood-bank/donors",
        link: "/blood-bank/donors",
        label: "Donors Management",
        icon: "ti-user",
        icon_type: "icon",
        key: "blood_bank_donors",
        type: "link"
      },
      {
        path: "/blood-bank/requests",
        link: "/blood-bank/requests",
        label: "Blood Requests",
        icon: "ti-clipboard",
        icon_type: "icon",
        key: "blood_bank_requests",
        type: "link"
      },
      {
        path: "/blood-bank/reports",
        link: "/blood-bank/reports",
        label: "Reports",
        icon: "ti-bar-chart",
        icon_type: "icon",
        key: "blood_bank_reports",
        type: "link"
      },
      {
        path: "/blood-bank/notifications",
        link: "/blood-bank/notifications",
        label: "Notifications",
        icon: notificationsIcon,
        icon_type: "image",
        key: "blood_bank_notifications",
        type: "link"
      },
      {
        path: "/blood-bank/profile",
        link: "/blood-bank/profile",
        label: "Profile Settings",
        icon: profileIcon,
        icon_type: "image",
        key: "blood_bank_profile",
        type: "link"
      },
      {
        path: "#",
        link: "#",
        label: "Logout",
        icon: "ti-shift-right",
        icon_type: "icon",
        key: "blood_bank_logout",
        type: "action",
        action: "logout"
      },
    ];
  }

  /**
   * Build Diagnostic menu
   * @param {Object} userdata - User data
   * @returns {Array} Menu array
   */
  buildDiagnosticMenu(userdata) {
    return [
      {
        path: "/diagnostic/dashboard",
        link: "/diagnostic/dashboard",
        label: "Dashboard",
        icon: dashboardIcon,
        icon_type: "image",
        key: "diagnostic_dashboard",
        type: "link"
      },
      {
        path: "/diagnostic/tests",
        link: "/diagnostic/tests",
        label: "Tests & Prices",
        icon: "ti-medall",
        icon_type: "icon",
        key: "diagnostic_tests",
        type: "link"
      },
      {
        path: "/diagnostic/appointments",
        link: "/diagnostic/appointments",
        label: "Appointments",
        icon: appointmentsIcon,
        icon_type: "image",
        key: "diagnostic_appointments",
        type: "link"
      },
      {
        path: "/diagnostic/patients",
        link: "/diagnostic/patients",
        label: "Patients",
        icon: userIcon,
        icon_type: "image",
        key: "diagnostic_patients",
        type: "link"
      },
      {
        path: "/diagnostic/reports",
        link: "/diagnostic/reports",
        label: "Reports",
        icon: dashboardIcon,
        icon_type: "image",
        key: "diagnostic_reports",
        type: "link"
      },
      {
        path: "/diagnostic/notifications",
        link: "/diagnostic/notifications",
        label: "Notifications",
        icon: notificationsIcon,
        icon_type: "image",
        key: "diagnostic_notifications",
        type: "link"
      },
      {
        path: "/diagnostic/profile",
        link: "/diagnostic/profile",
        label: "Profile Settings",
        icon: profileIcon,
        icon_type: "image",
        key: "diagnostic_profile",
        type: "link"
      },
      {
        path: "#",
        link: "#",
        label: "Logout",
        icon: settingsIcon,
        icon_type: "image",
        key: "diagnostic_logout",
        type: "action",
        action: "logout"
      },
    ];
  }

  buildUserMenu(userdata, displayName) {
    return [
      {
        path: "/user-dashboard",
        link: "/user-dashboard",
        label: "Dashboard",
        icon: dashboardIcon,
        icon_type: "image",
        key: "user_dashboard",
        type: "link"
      },
      {
        path: "/user-appointments",
        link: "/user-appointments",
        label: "My Appointments",
        icon: appointmentsIcon,
        icon_type: "image",
        key: "user_appointments",
        type: "link"
      },
      {
        path: "/medical-records",
        link: "/medical-records",
        label: "Medical Records",
        icon: medicalRecordsIcon,
        icon_type: "image",
        key: "medical_records",
        type: "link"
      },
      {
        path: "/user-wishlist",
        link: "/user-wishlist",
        label: "My Wishlist",
        icon: wishlistIcon,
        icon_type: "image",
        key: "user_wishlist",
        type: "link"
      },
      {
        path: "/user-notifications",
        link: "/user-notifications",
        label: "Notifications",
        icon: notificationsIcon,
        icon_type: "image",
        key: "user_notifications",
        type: "link"
      },
      {
        path: "/user-insurance",
        link: "/user-insurance",
        label: "Insurance",
        icon: policiesIcon,
        icon_type: "image",
        key: "user_insurance",
        type: "link"
      },
      {
        path: "/user-profile",
        link: "/user-profile/personal-details",
        label: "Profile Settings",
        icon: profileIcon,
        icon_type: "image",
        key: "user_profile",
        type: "link"
      },
      {
        path: "/",
        link: "/",
        label: "Book New Appointment",
        icon: bookAppointmentIcon,
        icon_type: "image",
        key: "book_appointment",
        type: "link"
      },
      {
        path: "#",
        link: "#",
        label: "Logout",
        icon: settingsIcon,
        icon_type: "image",
        key: "user_logout",
        type: "action",
        action: "logout"
      }
    ];
  }
  /**
   * Build doctor menu
   * @param {Object} userdata - User data
   * @param {string} displayName - User display name
   * @returns {Array} Menu array
   */
  buildDoctorMenu(userdata, displayName) {
    return [
      {
        path: `/doctor/dashboard/${encryptId(userdata.id)}`,
        link: `/doctor/dashboard/${encryptId(userdata.id)}`,
        label: "Dashboard",
        icon: dashboardIcon,
        icon_type: "image",
        key: "doctor_dashboard",
        type: "link"
      },
      {
        path: `/doctor/${formatUrlString(displayName)}/${encryptId(userdata.id)}`,
        link: `/doctor/${formatUrlString(displayName)}/${encryptId(userdata.id)}`,
        label: "View My Profile",
        icon: viewIcon,
        icon_type: "image",
        key: "doctor_view_profile",
        type: "external",
        external: true,
      },
      {
        path: "/doctor/inbox",
        link: "/doctor/inbox",
        label: "Inbox",
        icon: inboxIcon,
        icon_type: "image",
        key: "doctor_inbox",
        type: "link"
      },
      {
        path: "/doctor/profile-settings/personal-details",
        link: "/doctor/profile-settings/personal-details",
        label: "Profile Settings",
        icon: profileIcon,
        icon_type: "image",
        key: "doctor_profile_settings",
        type: "link"
      },
      {
        path: "/doctor/specialitiesservices",
        link: "/doctor/specialitiesservices",
        label: "Specialities & Services",
        icon: medicalRecordsIcon,
        icon_type: "image",
        key: "doctor_specialities",
        type: "link"
      },
      {
        path: "/doctor/accountsettings/Security_&_Settings",
        link: "/doctor/accountsettings/Security_&_Settings",
        label: "Account Settings",
        icon: settingsIcon,
        icon_type: "image",
        key: "doctor_account_settings",
        type: "link"
      },
      {
        path: "/doctor/appointments-management",
        link: "/doctor/appointments-management",
        label: "Appointments",
        icon: appointmentsIcon,
        icon_type: "image",
        key: "doctor_appointments",
        type: "link",
        children: [
          {
            path: "/doctor/appointmentlist",
            link: "/doctor/appointmentlist",
            label: "Appointment List",
            icon: appointmentsIcon,
            icon_type: "image",
            key: "doctor_appointment_list",
            type: "link",
            level: 1
          },
          {
            path: "/doctor/appointmentsettings",
            link: "/doctor/appointmentsettings",
            label: "Appointment Settings",
            icon: settingsIcon,
            icon_type: "image",
            key: "doctor_appointment_settings",
            type: "link",
            level: 1
          }
        ]
      },
      {
        path: "/doctor/managarticle",
        link: "/doctor/managarticle",
        label: "Manage Article",
        icon: articleIcon,
        icon_type: "image",
        key: "doctor_manage_article",
        type: "link"
      },
      {
        path: "/doctor/payoutssettings",
        link: "/doctor/payoutssettings",
        label: "Payouts Settings",
        icon: appointmentsIcon,
        icon_type: "image",
        key: "doctor_payouts",
        type: "link"
      },
      {
        path: "/doctor/mysaveditems",
        link: "/doctor/mysaveditems",
        label: "My Saved Items",
        icon: wishlistIcon,
        icon_type: "image",
        key: "doctor_saved_items",
        type: "link"
      },
      {
        path: "/doctor/packages",
        link: "/doctor/packages",
        label: "Packages",
        icon: packagesIcon,
        icon_type: "image",
        key: "doctor_packages",
        type: "link"
      },
      {
        path: "/doctor/doctor-marketing",
        link: "/doctor/doctor-marketing",
        label: "Marketing",
        icon: dashboardIcon,
        icon_type: "image",
        key: "doctor_marketing",
        type: "link"
      },
      {
        path: "/doctor/invoices",
        link: "/doctor/invoices",
        label: "Invoices",
        icon: articleIcon,
        icon_type: "image",
        key: "doctor_invoices",
        type: "link"
      },
      {
        path: "#",
        link: "#",
        label: "Logout",
        icon: settingsIcon,
        icon_type: "image",
        key: "doctor_logout",
        type: "action",
        action: "logout"
      },
    ];
  }

  /**
   * Build hospital menu
   * @param {Object} userdata - User data
   * @param {string} displayName - User display name
   * @returns {Array} Menu array
   */
  buildHospitalMenu(userdata, displayName) {
    return [
      {
        path: "/hospital/dashboard",
        link: "/hospital/dashboard",
        label: "Dashboard",
        icon: dashboardIcon,
        icon_type: "image",
        key: "hospital_dashboard",
        type: "link"
      },
      {
        path: "/hospital/profile",
        link: `/hospital/${formatUrlString(displayName)}/${encryptId(userdata.id)}`,
        label: "View My Profile",
        icon: viewIcon,
        icon_type: "image",
        key: "hospital_view_profile",
        type: "external",
        target: "_blank"
      },
      {
        path: "/hospital/inbox",
        link: "/hospital/inbox",
        label: "Inbox",
        icon: inboxIcon,
        icon_type: "image",
        key: "hospital_inbox",
        type: "link"
      },
      {
        path: "/hospital/profilesettings/hospital-details",
        link: "/hospital/profilesettings/hospital-details",
        label: "Profile Settings",
        icon: profileIcon,
        icon_type: "image",
        key: "hospital_profile_settings",
        type: "link"
      },
      {
        path: "/hospital/specialitiesservices",
        link: "/hospital/specialitiesservices",
        label: "Specialities & Services",
        icon: medicalRecordsIcon,
        icon_type: "image",
        key: "hospital_specialities",
        type: "link"
      },
      {
        path: "/hospital/mydoctors",
        link: "/hospital/mydoctors",
        label: "My Doctors",
        icon: doctorIcon,
        icon_type: "image",
        key: "hospital_my_doctors",
        type: "link"
      },
      {
        path: "/hospital/accountsettings/Security_&_Settings",
        link: "/hospital/accountsettings/Security_&_Settings",
        label: "Account Settings",
        icon: settingsIcon,
        icon_type: "image",
        key: "hospital_account_settings",
        type: "link"
      },
      {
        path: "/hospital/appointments-management",
        link: "/hospital/appointments-management",
        label: "Appointments",
        icon: appointmentsIcon,
        icon_type: "image",
        key: "hospital_appointments",
        type: "link",
        children: [
          {
            path: "/hospital/appointmentlist",
            link: "/hospital/appointmentlist",
            label: "Appointment List",
            icon: appointmentsIcon,
            icon_type: "image",
            key: "hospital_appointment_list",
            type: "link",
            level: 1
          },
          {
            path: "/hospital/appointmentsettings",
            link: "/hospital/appointmentsettings",
            label: "Appointment Settings",
            icon: settingsIcon,
            icon_type: "image",
            key: "hospital_appointment_settings",
            type: "link",
            level: 1
          }
        ]
      },
      {
        path: "/hospital/managarticle",
        link: "/hospital/managarticle",
        label: "Manage article",
        icon: articleIcon,
        icon_type: "image",
        key: "hospital_manage_article",
        type: "link"
      },
      {
        path: "/hospital/payoutssettings",
        link: "/hospital/payoutssettings",
        label: "Payouts Settings",
        icon: appointmentsIcon,
        icon_type: "image",
        key: "hospital_payouts",
        type: "link"
      },
      {
        path: "/hospital/packages",
        link: "/hospital/packages",
        label: "Packages",
        icon: packagesIcon,
        icon_type: "image",
        key: "hospital_packages",
        type: "link"
      },
      {
        path: "/hospital/marketing",
        link: "/hospital/marketing",
        label: "Marketing",
        icon: dashboardIcon,
        icon_type: "image",
        key: "hospital_marketing",
        type: "link"
      },
      {
        path: "/hospital/invoices",
        link: "/hospital/invoices",
        label: "Invoices",
        icon: articleIcon,
        icon_type: "image",
        key: "hospital_invoices",
        type: "link"
      },
      {
        path: "#",
        link: "#",
        label: "Logout",
        icon: settingsIcon,
        icon_type: "image",
        key: "hospital_logout",
        type: "action",
        action: "logout"
      }
    ];
  }

  /**
   * Build staff menu
   * @param {Object} userdata - User data
   * @param {string} displayName - User display name
   * @returns {Array} Menu array
   */
  buildStaffMenu(userdata, displayName) {
    return [
      {
        icon_type: "icon",
        label: "Dashboard",
        icon: "ti-desktop",
        key: "staff_dashboard",
        link: `/staff/dashboard?id=${encryptId(userdata.id)}`,
        active: false,
      },
      {
        icon_type: "icon",
        label: "View My Profile",
        icon: "ti-eye",
        key: "staff_profile",
        link: `/staff/profile?id=${encryptId(userdata.id)}`,
        active: false,
      },
      {
        icon_type: "icon",
        label: "Inbox",
        icon: "ti-email",
        key: "staff_inbox",
        link: "/staff/inbox",
        active: false,
      },
      {
        icon_type: "icon",
        label: "Profile Settings",
        icon: "ti-settings",
        key: "staff_profile_settings",
        link: "/staff/profile-settings",
        active: false,
      },
      {
        icon_type: "icon",
        label: "Activity Tracking",
        icon: "ti-eye",
        key: "staff_activity_tracking",
        link: "/staff/activity-tracking",
        active: false,
      },
      {
        icon_type: "icon",
        label: "Task Management",
        icon: "ti-credit-card",
        key: "staff_task_management",
        link: "/staff/task-management",
        active: false,
      },
      {
        icon_type: "icon",
        label: "Logout",
        icon: "ti-shift-right",
        key: "staff_logout",
        link: "#",
        active: false,
        type: "action",
        action: "logout"
      },
    ];
  }

  /**
   * Build pharmacy menu
   * @param {Object} userdata - User data
   * @returns {Array} Menu array
   */
  buildPharmacyMenu(userdata) {
    return [
      {
        path: "/pharmacy/dashboard",
        link: "/pharmacy/dashboard",
        label: "Dashboard",
        icon: dashboardIcon,
        icon_type: "image",
        key: "pharmacy_dashboard",
        type: "link",
      },
      {
        path: "/pharmacy/inbox",
        link: "/pharmacy/inbox",
        label: "Inbox / Messages",
        icon: inboxIcon,
        icon_type: "image",
        key: "pharmacy_inbox",
        type: "link",
      },
      {
        path: "/pharmacy/profilesettings",
        link: "/pharmacy/profilesettings/pharmacy-details",
        label: "Profile Settings",
        icon: profileIcon,
        icon_type: "image",
        key: "pharmacy_profile_settings",
        type: "link",
        children: [
          {
            path: "/pharmacy/profilesettings/pharmacy-details",
            link: "/pharmacy/profilesettings/pharmacy-details",
            label: "Pharmacy Details",
            icon: userIcon,
            icon_type: "image",
            key: "pharmacy_profile_details",
            type: "link",
            level: 1,
          },
        ],
      },
      {
        path: "/pharmacy/specialitiesservices",
        link: "/pharmacy/specialitiesservices",
        label: "Specialities & Services",
        icon: medicalRecordsIcon,
        icon_type: "image",
        key: "pharmacy_specialities_services",
        type: "link",
      },
      {
        path: "/pharmacy/accountsettings",
        link: "/pharmacy/accountsettings/Security_&_Settings",
        label: "Account Settings",
        icon: settingsIcon,
        icon_type: "image",
        key: "pharmacy_account_settings",
        type: "link",
      },
      {
        path: "/pharmacy/products",
        link: "/pharmacy/products",
        label: "Products",
        icon: shopIcon,
        icon_type: "image",
        key: "pharmacy_products",
        type: "link",
      },
      {
        path: "/pharmacy/orders",
        link: "/pharmacy/orders/new",
        label: "Orders",
        icon: articleIcon,
        icon_type: "image",
        key: "pharmacy_orders",
        type: "link",
        children: [
          {
            path: "/pharmacy/orders/new",
            link: "/pharmacy/orders/new",
            label: "New Orders",
            icon: shopIcon,
            icon_type: "image",
            key: "pharmacy_orders_new",
            type: "link",
            level: 1,
          },
          {
            path: "/pharmacy/orders/history",
            link: "/pharmacy/orders/history",
            label: "Order History",
            icon: articleIcon,
            icon_type: "image",
            key: "pharmacy_orders_history",
            type: "link",
            level: 1,
          },
        ],
      },
      {
        path: "/pharmacy/inventory",
        link: "/pharmacy/inventory",
        label: "Inventory",
        icon: shopIcon,
        icon_type: "image",
        key: "pharmacy_inventory",
        type: "link",
        children: [
          {
            path: "/pharmacy/inventory",
            link: "/pharmacy/inventory",
            label: "Inventory Overview",
            icon: viewIcon,
            icon_type: "image",
            key: "pharmacy_inventory_overview",
            type: "link",
            level: 1,
          },
          {
            path: "/pharmacy/inventory/low-stock",
            link: "/pharmacy/inventory/low-stock",
            label: "Low Stock",
            icon: "ti-alert",
            icon_type: "icon",
            key: "pharmacy_inventory_low_stock",
            type: "link",
            level: 1,
          },
          {
            path: "/pharmacy/inventory/expiry",
            link: "/pharmacy/inventory/expiry",
            label: "Upcoming Expiry",
            icon: "ti-timer",
            icon_type: "icon",
            key: "pharmacy_inventory_expiry",
            type: "link",
            level: 1,
          },
        ],
      },
      {
        path: "/pharmacy/procurement",
        link: "/pharmacy/procurement",
        label: "Procurement",
        icon: "ti-truck",
        icon_type: "icon",
        key: "pharmacy_procurement",
        type: "link",
      },
      {
        path: "/pharmacy/invoices",
        link: "/pharmacy/invoices",
        label: "Invoices",
        icon: "ti-receipt",
        icon_type: "icon",
        key: "pharmacy_invoices",
        type: "link",
        children: [
          {
            path: "/pharmacy/invoices",
            link: "/pharmacy/invoices",
            label: "Sales Invoices",
            icon: "ti-receipt",
            icon_type: "icon",
            key: "pharmacy_invoices_sales",
            type: "link",
            level: 1,
          },
          {
            path: "/pharmacy/vendor-invoices",
            link: "/pharmacy/vendor-invoices",
            label: "Vendor Invoices",
            icon: "ti-briefcase",
            icon_type: "icon",
            key: "pharmacy_invoices_vendor",
            type: "link",
            level: 1,
          },
        ],
      },
      {
        path: "/pharmacy/payoutssettings",
        link: "/pharmacy/payoutssettings",
        label: "Payouts Settings",
        icon: "ti-credit-card",
        icon_type: "icon",
        key: "pharmacy_payouts",
        type: "link",
      },
      {
        path: "/pharmacy/sales-reports",
        link: "/pharmacy/sales-reports",
        label: "Sales Reports",
        icon: "ti-bar-chart",
        icon_type: "icon",
        key: "pharmacy_sales_reports",
        type: "link",
      },
      {
        path: "/pharmacy/packages",
        link: "/pharmacy/packages",
        label: "Packages",
        icon: "ti-gift",
        icon_type: "icon",
        key: "pharmacy_packages",
        type: "link",
      },
      {
        path: "/pharmacy/marketing",
        link: "/pharmacy/marketing",
        label: "Marketing & Promotions",
        icon: "ti-megaphone",
        icon_type: "icon",
        key: "pharmacy_marketing",
        type: "link",
      },
      {
        path: "/pharmacy/prescriptions",
        link: "/pharmacy/prescriptions",
        label: "Prescription Requests",
        icon: "ti-clipboard",
        icon_type: "icon",
        key: "pharmacy_prescriptions",
        type: "link",
      },
      {
        path: "/pharmacy/mysaveditems",
        link: "/pharmacy/mysaveditems",
        label: "My Saved Items",
        icon: "ti-heart",
        icon_type: "icon",
        key: "pharmacy_saved_items",
        type: "link",
      },
      {
        path: "#",
        link: "#",
        label: "Logout",
        icon: "ti-shift-right",
        icon_type: "icon",
        key: "pharmacy_logout",
        type: "action",
        action: "logout",
      },
    ];
  }

  /**
   * Build generic menu for other user types
   * @param {Object} userdata - User data
   * @returns {Array} Menu array
   */
  buildGenericMenu(userdata) {
    return [
      {
        path: `/${userdata.user_type}-dashboard`,
        label: "Dashboard",
        icon: dashboardIcon,
        icon_type: "image"
      },
    ];
  }

  /**
   * Process menu items to support submenus
   * @param {Array} menu - Menu array
   * @returns {Array} Processed menu array
   */
  processMenuForSubmenus(menu) {
    return menu.map(item => ({
      ...item,
      children: item.children || [],
      hasChildren: (item.children && item.children.length > 0) || false,
      expanded: false,
      level: item.level || 0
    }));
  }

  /**
   * Create a menu item with submenu support
   * @param {Object} item - Menu item object
   * @param {Array} children - Child menu items
   * @returns {Object} Enhanced menu item
   */
  createMenuItem(item, children = []) {
    return {
      ...item,
      children: children,
      hasChildren: children.length > 0,
      expanded: false,
      level: item.level || 0
    };
  }

  /**
   * Add submenu to parent menu item
   * @param {Array} menu - Menu array
   * @param {string} parentPath - Parent menu path
   * @param {Object} submenuItem - Submenu item
   * @returns {boolean} Success status
   */
  addSubmenu(menu, parentPath, submenuItem) {
    const parent = this.getMenuItemByPath(menu, parentPath);
    if (parent) {
      if (!parent.children) {
        parent.children = [];
      }
      parent.children.push(submenuItem);
      parent.hasChildren = parent.children.length > 0;
      return true;
    }
    return false;
  }

  /**
   * Get submenu items for a parent menu
   * @param {Array} menu - Menu array
   * @param {string} parentPath - Parent menu path
   * @returns {Array} Submenu items
   */
  getSubmenuItems(menu, parentPath) {
    const parent = this.getMenuItemByPath(menu, parentPath);
    return parent ? parent.children || [] : [];
  }

  /**
   * Toggle submenu expanded state
   * @param {Array} menu - Menu array
   * @param {string} parentPath - Parent menu path
   * @returns {boolean} New expanded state
   */
  toggleSubmenu(menu, parentPath) {
    const parent = this.getMenuItemByPath(menu, parentPath);
    if (parent) {
      parent.expanded = !parent.expanded;
      return parent.expanded;
    }
    return false;
  }

  /**
   * Check if any submenu is expanded
   * @param {Array} menu - Menu array
   * @returns {boolean} True if any submenu is expanded
   */
  hasExpandedSubmenu(menu) {
    return menu.some(item => {
      if (item.expanded) return true;
      if (item.children) {
        return this.hasExpandedSubmenu(item.children);
      }
      return false;
    });
  }

  /**
   * Close all expanded submenus
   * @param {Array} menu - Menu array
   */
  closeAllSubmenus(menu) {
    menu.forEach(item => {
      item.expanded = false;
      if (item.children) {
        this.closeAllSubmenus(item.children);
      }
    });
  }

  /**
   * Close other expanded submenus except the selected one
   * @param {Array} menu - Menu array
   * @param {string} excludePath - Path to exclude from closing
   */
  closeOtherSubmenus(menu, excludePath) {
    menu.forEach(item => {
      if (item.path !== excludePath) {
        item.expanded = false;
        if (item.children) {
          this.closeOtherSubmenus(item.children, excludePath);
        }
      }
    });
  }

  /**
   * Check if path is part of any submenu
   * @param {Array} menu - Menu array
   * @param {string} targetPath - Path to check
   * @returns {Object|null} Parent menu item or null
   */
  findParentMenu(menu, targetPath) {
    for (const item of menu) {
      if (item.children) {
        const foundInChildren = item.children.find(child => child.path === targetPath);
        if (foundInChildren) {
          return item;
        }
        const foundInNested = this.findParentMenu(item.children, targetPath);
        if (foundInNested) {
          return foundInNested;
        }
      }
    }
    return null;
  }

  /**
   * Clear menu cache
   */
  clearCache() {
    this.menuCache.clear();
  }

  /**
   * Get menu item by path
   * @param {Array} menu - Menu array
   * @param {string} path - Path to find
   * @returns {Object|null} Menu item or null
   */
  getMenuItemByPath(menu, path) {
    return menu.find(item => item.path === path) || null;
  }

  /**
   * Check if current path is active
   * @param {string} currentPath - Current pathname
   * @param {string} menuPath - Menu item path
   * @returns {boolean}
   */
  isActivePath(currentPath, menuPath) {
    return currentPath === menuPath;
  }

  isActiveSubmenu(currentPath, menuPath) {
    return currentPath.includes(menuPath) && menuPath.includes(currentPath);
  }
}

// Export singleton instance
export default new SidebarController();
